export const renderCssRoot = (listEnvInfo = []) => {
  const cssVariables = (listEnvInfo || []).filter((item) => item?.description?.includes('WEB_'));
  let cssInnerHTML = '';

  if (cssVariables && cssVariables.length > 0) {
    let cssData = {
      css_variables: [],
      css_classes: {},
    };
    cssData.css_variables = cssVariables.filter(item => item.code.startsWith('--')).map(t => {
      return {
        key: t.code,
        value: t.content,
      };
    });
    const cssClasses = cssVariables.filter(item => item.code.startsWith('.') || item.code.startsWith('#')).reduce((hash, obj) => {
      if (obj['code'] === undefined) {
        return hash;
      }
      return Object.assign(hash, { [obj['code']]: (hash[obj['code']] || []).concat(obj) });
    }, {});

    cssData.css_classes = cssClasses;

    let cssInnerHTMLMobile = '@media (max-width: 480px) {';
    if (cssData.css_variables.length > 0) {
      cssInnerHTML = `:root{`;
      cssData.css_variables.map(t => {
        if (!t.key.includes('-mobile')) {
          cssInnerHTML += `${t.key}: ${t.value};`;
        } else {
          if (cssInnerHTMLMobile === '@media (max-width: 480px) {') cssInnerHTMLMobile += ':root{';
          cssInnerHTMLMobile += `${t.key.replace('-mobile', '')}: ${t.value};`;
        }
      });
      cssInnerHTML += '}';

      if (cssInnerHTMLMobile !== '@media (max-width: 480px) {') {
        cssInnerHTMLMobile += '}}';
        cssInnerHTML += cssInnerHTMLMobile;
        cssInnerHTMLMobile = '@media (max-width: 480px) {';
      }
    }
    if (Object.keys(cssData.css_classes).length > 0) {
      Object.keys(cssData.css_classes).map(t => {
        if (!t.includes('-mobile')) {
          cssInnerHTML += `${t}{${cssData.css_classes[t].map(k => k.content).join(';')}}`;
        } else {
          cssInnerHTMLMobile += `${t.replace('-mobile', '')}{${cssData.css_classes[t].map(k => k.content).join(';')}}`;
        }
      });
      if (cssInnerHTMLMobile !== '@media (max-width: 480px) {') {
        cssInnerHTMLMobile += '}';
        cssInnerHTML += cssInnerHTMLMobile;
      }
    }
  }

  return cssInnerHTML;
};
